export namespace BMIUtils {
    export function calculateBMI(height: number, weight: number) {
        height /= 100;
        var imc;
        imc = height === 0 ? 0 : (weight / Math.pow(height, 2));
        return (imc = Math.round(imc * 100) / 100);
    }
}
